import { RootState } from "@store/index";

export const reportingEmbedTokenConfigSelector = (state: RootState) => state.reporting.embedTokenConfig;
